const worker = new Worker("./upload-worker.js", { type: "module" });

const send = message => {
  worker.postMessage(message);
};

export default {
  worker,
  send
};
